module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/ab820e7f2bb9ef49281f0f7880abb87e.png";